import {
    getAreas,
    getAreasWithApps,
    getAreasByAppKod,
    getGroups,
    getRoles,
    getRolesByAppsIds,
    checkRoleDependencies,
    deleteRoles,
    createRoles,
    updateRoleData,
} from '@/service/admin-service';

import enviromentStore from '@/store/enviroment-data';
import { reactive } from 'vue';

const rolesState = reactive({
    formRef: null,
    roleList: [],
    roleListByApp: [],
    rolesByAppsIds: [],
    areaList: [],
    areaListByAppKod: [],
    groupList: [],
    areaListWithApps: [],
    roleDependenciesList: [],
});

const setFormRef = value => {
    rolesState.formRef = value;
};

const setRoleForm = value => {
    rolesState.setFormRef = value;
};

const getRolesByApps = async (apps) => {
    const response = await getRolesByAppsIds(apps);
    rolesState.rolesByAppsIds = response.success
        ? response.data.map(item => item.role)
        : [];
};

const getRoleList = async app_id => {
    if (app_id) {
        const args = { app_id };
        const items = await getRoles(args);
        if (items) {
            rolesState.roleListByApp = items;
        }
    } else {
        const roles = await getRoles(null);
        if (roles) {
            rolesState.roleList = roles;
        }
    }
    return true;
};

const getAreaList = async () => {
    const items = await getAreas();
    if (items) {
        rolesState.areaList = items;
    }
    return true;
};

const getGroupList = async () => {
    const items = await getGroups();
    if (items) {
        rolesState.groupList = items;
    }
    return true;
};

const getAreaListByAppKod = async (kod_app, for_departs = true) => {
    const items = await getAreasByAppKod(kod_app, for_departs);
    if (items) {
        rolesState.areaListByAppKod = items;
    }
    return true;
};

const getAreaListWithApps = async () => {
    const items = await getAreasWithApps();
    items.forEach((it, index) => {
        items[index].apps = it.apps?.map(
            appId => enviromentStore.state.appList.find(app => app.kod_app === appId)?.name_app,
        );
    });
    if (items) {
        rolesState.areaListWithApps = items;
    }
    return true;
};

const getRoleDependencies = async roleIds => {
    const items = await checkRoleDependencies({ roleIds });
    rolesState.roleDependenciesList = items;
    return true;
};

const deleteRole = async roleIds => {
    const response = await deleteRoles(roleIds);
    getRoleList();
    return response;
};

const createRole = async requestBody => {
    const response = await createRoles(requestBody);
    return response;
};

const updateRole = async requestBody => {
    const response = await updateRoleData(requestBody);
    return response;
};

const getRolesDisplayList = () => {
    return rolesState.roleListByApp.map(role => {
        const { areas, ...rest } = role;
        const areaNames = [];
        for (const obj of areas) {
            if (!areaNames.includes(obj.name)) {
                areaNames.push(obj.name);
            }
        }
        const joinedAreaNames = areaNames.join(', ');
        return { ...rest, joinedAreaNames };
    });
};

const getHighLevelGroups = () => {
    return rolesState.groupList?.filter(group => group.parent_id === null);
};

const getGroupedAreaList = areaListSource => {
    const areas = rolesState[areaListSource].map(item => {
        const area = { ...item };
        area.parent_id = area.group_id;
        area.displayId = `${area.id}:a`;
        return area;
    });

    const groups = rolesState.groupList.map(groupItem => {
        const group = { ...groupItem };
        group.displayId = group.id;
        group.name = `Группа: ${group.name}`;
        group.isGroup = true;
        return group;
    });

    return [...groups, ...areas];
};

export default {
    rolesState,
    setFormRef,
    setRoleForm,
    getRoleList,
    getAreaList,
    getGroupList,
    getAreaListByAppKod,
    getAreaListWithApps,
    getRoleDependencies,
    deleteRole,
    createRole,
    updateRole,
    getRolesByApps,
    getRolesDisplayList,
    getHighLevelGroups,
    getGroupedAreaList,
};
